import React, { useContext, useEffect, useState } from "react";
import userContext from "../../context/users/UserContext";
import { USERTYPES } from "../../constants/Constants";
import NotAuthorized from "../../components/NotAuthorized";
import { useTranslation } from "react-i18next";

import {
  DatePicker,
  DayOfWeek,
  Dropdown,
  IDropdownOption,
  mergeStyles,
  defaultDatePickerStrings,
  PrimaryButton,
} from "@fluentui/react";
import "./Billing.css"; // Import your CSS file
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import moment from "moment";
import {
  downloadBillingReport,
  getHospitalList,
} from "../../service/BillingService";
import { useFormik } from "formik";
import loaderContext from "../../context/loader/LoaderContext";
import Select from "react-select";
const datePickerStyles = {
  readOnlyTextField: {
    border: "none",
  },
  asterisk: {
    color: "red",
  },
};

const Billing = () => {
  const [t, i18n] = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [firstDayOfWeek, setFirstDayOfWeek] = React.useState(DayOfWeek.Sunday);
  const onDropdownChange = React.useCallback((event, option) => {
    setFirstDayOfWeek(option.key);
  }, []);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);
  const [showFromRequired, setShowFromRequiredMessage] = useState(false);
  const [showToRequired, setShowToRequiredMessage] = useState(false);
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [hospitalList, setHospitalList] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState(null);
  // const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  useEffect(() => {
    if (!authenticated) {
      console.log("--- Authentication again ----");
      loadByUsername();
      return;
    }
  }, [authenticated]);

  const fetchData = async () => {
    try {
      const data = await getHospitalList();
      if (data) {
        console.log(data);
        setHospitalList(
          data.map((d) => {
            return {
              value: d.id,
              label: d.name,
            };
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (authenticated) fetchData();
  }, [authenticated]);

  const formatDate = (date) => {
    var currentDate = moment(date).local().format("DD-MMM-YYYY");
    return date == "" ? "" : currentDate;
  };
  const [filterObj, setFilterObj] = useState({
    dateFrom: firstDayOfMonth,
    dateTo: today,
  });
  const breadCrumbItems = [
    {
      text: "Billing",
      key: "billing",
    },
  ];

  const addIcon = {
    iconName: "Download",
    cursor: "pointer",
  };

  const selectDateFrom = (date) => {
    setShowFromRequiredMessage(false);
    setFilterObj({ ...filterObj, dateFrom: date });
  };

  const selectDateTo = (date) => {
    setShowToRequiredMessage(false);
    setFilterObj({ ...filterObj, dateTo: date });
  };

  const DownloadReport = async () => {
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const data = {
        toDate: formatDate(filterObj.dateTo),
        fromDate: formatDate(filterObj.dateFrom),
        firmId: roles[0] === USERTYPES.ADMIN ? selectedHospital.value : firmId,
      };
      let res = await downloadBillingReport(data);
      setLoaderRunning(false);
      ref.current.complete();
      setErrorMessage("");
    } catch (error) {
      console.error("Error during form validation:", error);
    }
  };
  const billingPayload = () => {
    return {
      dateFrom: formatDate(filterObj.dateFrom),
      dateTo: formatDate(filterObj.dateTo),
    };
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    validateForm,
  } = useFormik({
    initialValues: {
      dateFrom: "",
      dateTo: "",
    },
    onSubmit: async (values, actions) => {
      let payload = billingPayload();
      if (roles[0] === USERTYPES.ADMIN && !selectedHospital) {
        setErrorMessage(t("billing.error.select-firm-error"));
        return;
      }
      if (!payload.dateFrom) {
        setShowFromRequiredMessage(true);
        // setErrorMessage(t("billing.error.from-date-required"));
        return;
      } else if (!payload.dateTo) {
        setShowToRequiredMessage(true);
        // setErrorMessage(t("billing.error.to-date-required"));
        return;
      } else {
        const fromDate = new Date(payload.dateFrom);
        const toDate = new Date(payload.dateTo);
        console.log(payload);
        if (fromDate > toDate) {
          setErrorMessage(t("billing.error.from-to-date-not-correct"));
          return;
        }

        const dateDifference = toDate - fromDate;
        const daysDifference = Math.ceil(
          dateDifference / (1000 * 60 * 60 * 24)
        );
        if (daysDifference >= 31) {
          setErrorMessage(t("billing.error.date-difference-greater-than-31"));
          return;
        }
      }
      DownloadReport();
    },
  });

  const handleHospitalChange = (item) => {
    setSelectedHospital(item);
  };

  return (
    <>
      {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div className="billing-div">
            <div className="date-picker-container">
              {roles[0] === USERTYPES.ADMIN && (
                <div style={{ width: "200px", paddingBottom: "5px" }}>
                  <span className="billing-label">
                    Select firm <span style={{ color: "red" }}>*</span>
                  </span>
                  <Select
                    label="Select firm"
                    classNamePrefix="react-select"
                    options={hospitalList}
                    value={selectedHospital}
                    // placeholder="Select firm"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        width: "100% !important",
                        background: "#161616 !important",
                        border: "1px solid rgb(191, 191, 191) !important",
                      }),
                      menu: (baseStyles) => ({
                        ...baseStyles,
                        width: "100% !important",
                      }),
                      option: (
                        styles,
                        { data, isDisabled, isFocused, isSelected }
                      ) => {
                        return {
                          ...styles,
                          backgroundColor: isSelected ? "#4C9AFF" : undefined,
                        };
                      },
                    }}
                    onChange={(item) => {
                      handleHospitalChange(item);
                    }}
                  />
                </div>
              )}
              <div style={{ width: "200px" }}>
                <DatePicker
                  firstDayOfWeek={firstDayOfWeek}
                  value={filterObj.dateFrom}
                  // placeholder={t("billing.from")}
                  placeholder="dd-mmm-yyyy"
                  onSelectDate={selectDateFrom}
                  strings={defaultDatePickerStrings}
                  maxDate={today}
                  isRequired={true}
                  label={t("common.from")}
                  formatDate={(date) => {
                    const day = date.getDate().toString().padStart(2, "0");
                    const month = new Intl.DateTimeFormat("en", {
                      month: "short",
                    }).format(date);
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                  }}
                  styles={datePickerStyles}
                />
              </div>

              <div style={{ width: "200px" }}>
                <DatePicker
                  firstDayOfWeek={firstDayOfWeek}
                  value={filterObj.dateTo}
                  // placeholder={t("billing.to")}
                  placeholder="dd-mmm-yyyy"
                  onSelectDate={selectDateTo}
                  strings={defaultDatePickerStrings}
                  maxDate={today}
                  isRequired={true}
                  label={t("common.to")}
                  formatDate={(date) => {
                    const day = date.getDate().toString().padStart(2, "0");
                    const month = new Intl.DateTimeFormat("en", {
                      month: "short",
                    }).format(date);
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                  }}
                />
              </div>
              <div style={{ paddingBottom: "5px" }}>
                <PrimaryButton
                  iconProps={addIcon}
                  onClick={() => {
                    handleSubmit();
                  }}
                  text={t("billing.download")}
                />
              </div>
            </div>
            <div className="">
              <div
                className="form-mt-10"
                style={{
                  color: "red",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                {errorMessage}
              </div>
            </div>
          </div>
        </div>
      )}
      {roles.length != 0 && roles[0] === USERTYPES.RADIOLOGIST && (
        <NotAuthorized />
      )}
    </>
  );
};
export default Billing;
